import { mutations } from './mutations';
import { actions } from './actions';

const state = {
  evaluations: [],
  currentEvaluationId: null,
};

const getters = {
  getEvaluationById: (state) => (id) => {
    return state.evaluations.find((x) => x.studentEvaluationId === id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
